module.exports = __webpack_public_path__ + "static/media/logo-ringo-pad.07c029c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-ringo-pad.png
// module id = ./src/img/logo-ringo-pad.png
// module chunks = 0